export default "__VITE_ASSET__c249acc5__"